import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    initial: {
        loading: true,
        activeRequests: 0
    },
    inline: {
        loading: false
    }
};

const loaderSlice = createSlice({
    name: "loader",
    initialState,
    reducers: {
        setInitialLoading: (state, payload) => {
            state.initial.loading = payload.payload;
        },
        increaseRequests: (state) => {
            state.initial.activeRequests = state.initial.activeRequests + 1;
        },
        decreaseRequests: (state) => {
            state.initial.activeRequests = state.initial.activeRequests - 1;
        },
        setInlineLoading: (state, payload) => {
            state.inline.loading = payload.payload;
        }
    }
});

export const { setInitialLoading, increaseRequests, decreaseRequests, setInlineLoading } = loaderSlice.actions;
export default loaderSlice.reducer;